import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-link-underline__content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createBlock(_resolveDynamicComponent($props.as), {
    class: "gfu-link-underline",
    onClick: $options.onClick
  }, {
    default: _withCtx(() => [
      ($options.isIconBeforeVisible)
        ? (_openBlock(), _createBlock(_component_base_icon, {
            key: 0,
            name: $props.icon,
            class: "_mr-h"
          }, null, 8 /* PROPS */, ["name"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      ($options.isIconAfterVisible)
        ? (_openBlock(), _createBlock(_component_base_icon, {
            key: 1,
            name: $props.icon,
            class: "_ml-h"
          }, null, 8 /* PROPS */, ["name"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["onClick"]))
}